import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { CustomPanel, PageHeader } from '../../../../components'
import useGeoposicionamentoVeiculo, { LOAD_MESSAGE } from './GeoposicionamentoVeiculoHook'
import { MapWithRoute } from '../../../../services/Maps'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'

function GeoposicionamentoVeiculo({ dispatch, selectedTp, history }) {
  // Hooks
  const {
    location: {
      state: { fleet_id },
    },
  } = history
  const { state, localDispatch } = useGeoposicionamentoVeiculo()

  useEffect(() => {
    localDispatch.onInit()
  }, [])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.LOAD_DATA:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getGeolocationClientsByFleet(fleet_id)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  // Render
  return (
    <div>
      <PageHeader>Geoposicionamento Tp Drive</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          {state.geolocations.length ? (
            <div
              className="p-col-12"
              style={{
                height: 700,
                filter: state.isLoading ? 'blur(5px)' : 'none',
                pointerEvents: state.isLoading ? 'none' : 'all',
              }}
            >
              <MapWithRoute
                customers={state.customers}
                vehicleWaypoints={state.geolocations}
                changeLoadStatus={localDispatch.changeLoadStatus}
              />
            </div>
          ) : (
            <p>Sem dados de geolocalização do veículo</p>
          )}
        </CustomPanel>
      </div>
    </div>
  )
}

const mapToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapToProps)(withRouter(GeoposicionamentoVeiculo))
